import React from 'react'
import { Row, Col } from 'reactstrap';
import { Redirect, Switch, Route, useLocation } from "react-router-dom";
import { MenuDasFuncionalidades } from "../Menu/index";
import { connect } from 'react-redux';
import * as actionsRedux from '../Store/Actions/index';
import { CardCrud } from '../Conteudo/Cards/index';
import { convertToSlug } from '../Basicos/funcoes';
import SubgrupoAlunos from '../Conteudo/SubgruposAlunos';
import AssociadorDeGrupos from '../Conteudo/AssociadorDeGrupos';
import { FiltrosPeriodoSemestreTurma, FiltrosPeriodoSemestre } from '../Basicos/index';

// Algumas sub-telas precisam de um título diferente do nome genérico da funcionalidade
// ("Alunos") no topo — por slug da sub-funcionalidade ativa, não por rota, pra não depender da
// URL exata cadastrada.
const TITULOS_POR_SLUG = {
    "periodo-de-selecao-de-grupo": "Período de Seleção de Grupos",
    "configuracao-de-letra-do-grupo": "Configuração de Letra do Grupo",
};

function Alunos({ alunos, }) {
    const location = useLocation();
    const subFuncionalidadeAtual = alunos.find((subFuncionalidade) => location.pathname.startsWith(subFuncionalidade.url));
    const titulo = TITULOS_POR_SLUG[convertToSlug(subFuncionalidadeAtual?.descricao ?? "")] ?? "Alunos";

    return (
        <Row noGutters={true}>
            <MenuDasFuncionalidades
                funcionalidade={"alunos"}
                classNavBar="navbar-consultas"
                titulo={titulo}
            />
            <Col sm={12} md={12} className="col-conteudo">
                <Switch>
                    {alunos.map((subFuncionalidade, indice) => {
                        switch (convertToSlug(subFuncionalidade.descricao)) {
                            case "grupos":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <AssociadorDeGrupos
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"alunos"}
                                        />
                                        }
                                    />
                                );
                            case "subgrupos":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <SubgrupoAlunos
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"subgrupos"}
                                        />
                                        }
                                    />
                                );

                            case "periodo-de-selecao-de-grupo":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <CardCrud
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"alunos"}
                                            filtro={true}
                                            pesquisaGlobal={false}
                                            FiltroComponent={FiltrosPeriodoSemestre}
                                        />
                                        }
                                    />
                                );

                            case "configuracao-de-letra-do-grupo":
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <CardCrud
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"alunos"}
                                            filtro={true}
                                            pesquisaGlobal={false}
                                            FiltroComponent={FiltrosPeriodoSemestreTurma}
                                        />
                                        }
                                    />
                                );

                            default:
                                return (
                                    <Route
                                        key={subFuncionalidade.url}
                                        path={subFuncionalidade.url}
                                        render={(props) => <CardCrud
                                            {...props}
                                            subFuncionalidade={subFuncionalidade}
                                            indiceSubFuncionalidade={indice}
                                            funcionalidade={"alunos"}
                                        />
                                        }
                                    />
                                );
                        }
                    })}
                    <Route render={() => <Redirect to="/" />} />
                </Switch>
            </Col>
        </Row>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        desativarModal: () => dispatch(actionsRedux.desativarModalSubFuncionalidade()),
    }
}

const mapStateToProps = (state) => {
    return {
        alunos: state.subFuncionalidades.alunos,
        estruturaModal: state.subFuncionalidades.estruturaModal,
        estadoModal: state.subFuncionalidades.estadoModal,
        adicionar: state.subFuncionalidades.adicionar,
        editarFunc: state.subFuncionalidades.editar,
        tipoAcao: state.subFuncionalidades.tipoAcao,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Alunos)